<template>
<!--专家详情-->
  <div class="case-detail">
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section>
      <div class="page-content">
        <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: fromPath.path }" v-if="fromPath.path != '/'">{{ fromPath.meta && fromPath.meta.title }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ page.name }}详情</el-breadcrumb-item>
        </el-breadcrumb> 
        <div class="case-main">
            <div class="case-main-left" v-if="caseData">
                <img v-if="caseData.img" :src="caseData.img" class="case-img" />
                <div class="case-title">{{ caseData.title }}</div>
                <div class="case-time-author">
                    {{ caseData.author || '' }}
                    <span class="case-time">{{ caseData.createdate ? moment(caseData.createdate).format('YYYY-MM-DD') : ''}} </span>
                </div>
                <!-- <articleContent :content="caseData.content"></articleContent> -->
                <div class="case-content article-content" ref="caseContentRef"  v-html="caseData.content"></div>
<!-- 
                <iframe  @load="frm"  id="article-box" frameborder=0 name="showhere" scrolling=auto src="" :height="contentHeight" width="100%"></iframe> -->
            </div>
            <div class="case-main-right">
                <template v-if="related.length">
                <div class="case-main-right-title">相关{{ page.name }}</div>
                <ul class="right-list">
                    <li v-for="item in related" :key="item.id" class="right-list-item" @click="goto(item.id)">· {{ item.title || item.name }}</li>
                </ul>
                </template>
                <div v-if="attachments.length">
                <div class="case-main-right-title">附件</div>
                <ul class="right-list">
                    <li v-for="item in attachments" :key="item.id" class="right-list-item" @click="gotourl(item.url)">· {{ item.title || item.filename }}</li>
                </ul>
                </div>
            </div>
    

    
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "@/components/common/header.vue"
  import menuCmp from "@/components/common/navMenu.vue"
  import footerCmp from "@/components/common/footer.vue"
  import { getNewsDetail } from "@/api/news.js";
  import { getArticleList } from "@/api/home/index";
  import "@/assets/style/detail-reset.scss";

  import moment from "moment";

  export default{ 
    data(){ 
      return{ 
        id: this.$route.query.id,
        contentHeight:2000,
        caseData: null,
        related: [],
        attachments:[],
        fromPath: {},
        page: {
            case:{
                name: '案例',
                category: '案例'
            },
            directory:{
                name: '名录',
                category: '名录'
            }
        }[this.$route.query.type]
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp,

    },
    methods:{ 
        moment,
        /*****左侧详情&&右侧列表 */
        getContent(){
            const id = this.id;
            getNewsDetail({ id }).then(res=>{
                this.caseData = res.data;
                this.attachments = res.data.attachments;
            });
            getArticleList({
                pageIndex: 1,
                pageSize: 5,
                categorys: this.page.category,
            }).then(res=>{
                this.related = res.data.list.filter(i=>i.id != id);
            });
        },
        goto(id){
            this.$router.push(this.$route.fullPath.replace(/id=(\d)+/, 'id='+id))
        },
        gotourl(url){
            window.open(url);
        },
        // frm(){
	    //   let iframeBox=document.getElementById("article-box");
	    //   let _obj=iframeBox.contentWindow || iframeBox.contentDocument;
	    //   let doc=_obj.document;
        //  //iframeBox.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
        //   doc.body.innerHTML = this.caseData.content;
        //   _obj.height = doc.body.scrollHeight;
        //   this.contentHeight = doc.body.scrollHeight
        //   console.log(_obj,doc.body,doc.body.clientHeight,doc.body.scrollHeight);

         
    
    	// },

    },
    watch: {
        $route() {
            this.id = this.$route.query.id;
            this.getContent()
        }
    },
    mounted(){ 
        this.getContent();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.fromPath = from;
        });
    },
  }
</script>

<style lang="scss" scoped>
.case-detail{
    .breadcrumb{
        color: #666666;
        line-height: 20px;
        margin-top: 20px;
        ::v-deep{
            .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
                color: #DA5351;
            }
        }
    }
  .page-content{
    .case-main{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        &-left{
            width: 64.92%;
        }
        .case-img{
            width: auto;
            max-width: 100%;
            border-radius: 8px;
            margin-bottom: 32px;
            height: 200px;
        }
        .case-title{
            font-size: 34px;
            font-weight: 500;
            color: #333333;
            line-height: 46px;
        }
        .case-time-author{
            display: flex;
            justify-content: space-between;
            margin: 20px 0;
            color: #333;
            line-height: 20px;
            .case-time{
                color: #666;
            }
        }
        // .case-content{
        //     color: #454545;
        //     font-size: 16px;
        //     line-height: 24px;
        //     ::v-deep{
        //         p{
        //             color: #454545;
        //             font-size: 16px;
        //             line-height: 24px;
        //             text-indent: 2em;    
        //             word-break: break-all;
        //             white-space: normal;
        //         }
        //         strong{
        //             font-size: 18px;
        //             font-weight: 500;
        //             line-height: 32px;
        //         }
        //         img{
        //             max-width: 100%;
        //         }
        //         p>img{
        //             margin-left: -2em;
        //         }
        //     }
        // }
    }
    .case-main-right{
        font-weight: 500;
        width: 31.67%;
        &-title{
            font-size: 24px;
            color: #DA5351;
            line-height: 33px;
            margin-bottom: 18px;
        }
        .right-list{
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            &-item{
                cursor: pointer;
                margin-bottom: 16px;
            }
        }
    }
  }
}

@media screen and (max-width:960px){
    .case-detail{
        .header{
            margin-bottom: .16rem;
        }
        .page-content{
            .breadcrumb{
                display: none;
            }
            .case-main{
                padding-top: .20rem;
                flex-wrap: wrap;
                &-left, &-right{
                    width: 100%;
                }

                .case-img{
                    margin-bottom: .32rem;
                    height: 2rem;
                }
                .case-title{
                    font-size: .24rem;
                    line-height: .30rem;
                }
                .case-time-author{
                    font-size: .12rem;
                    line-height: .14rem;
                    .case-time{
                        float: right;
                    }
                }
                // .case-content{
                //     color: #454545;
                //     font-size: 16px;
                //     line-height: 24px;
                //     ::v-deep{
                //         p{
                //             font-size: .16rem;
                //             line-height: 1.5;
                //         }
                //         strong{
                //             font-size: .18rem;
                //             line-height: .32rem;
                //         }
                //     }
                // }
               
                .case-main-right{
                    margin-top: .24rem;
                    &-title{
                        font-size: .18rem;
                        color: #333333;
                        line-height: .24rem;
                        padding-bottom: .12rem;
                        border-bottom: 1px solid #F1F1F1;
                    }
                    .right-list{
                        font-size: .14rem;
                        font-weight: 400;
                        color: #454545;
                        line-height: .20rem;
                    }
                }
            }
        }
    }
}
</style>